import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../../util/reactIntl';
import { NamedLink } from '../../../../components';
import css from './OwnerFaqsTabEmptyState.module.css';

const OwnerFaqsTabEmptyState = ({ className }) => (
  <div className={classNames(css.root, className)}>
    <div className={css.titleWrapper}>
      <h2 className={css.title}>
        <FormattedMessage
          id="StoreProfilePage.tabs.faqs.ownerEmpty.title"
          defaultMessage="Frequently Asked Questions"
        />
      </h2>
    </div>

    <div className={css.contentWrapper}>
      <div className={css.art} aria-hidden="true">
        <i className={classNames('ri-question-line', css.artIcon)} />
      </div>

      <p className={css.description}>
        <FormattedMessage
          id="StoreProfilePage.tabs.faqs.ownerEmpty.description"
          defaultMessage="Answer common questions so renters know what to expect. Add and edit FAQs in Store Settings."
        />
      </p>
      <NamedLink name="StoreFaqsPage" className={css.cta}>
        <FormattedMessage
          id="StoreProfilePage.tabs.faqs.ownerEmpty.cta"
          defaultMessage="Add FAQs"
        />
        <i className={classNames('ri-arrow-right-up-line', css.ctaArrow)} aria-hidden />
      </NamedLink>
    </div>
  </div>
);

OwnerFaqsTabEmptyState.propTypes = {
  className: PropTypes.string,
};

export default OwnerFaqsTabEmptyState;
